const firebaseConfig = {
    apiKey: "AIzaSyCWb1dkpp_qivKXpunzax_FVQkg33Y5pww",
    authDomain: "smooth-rider.firebaseapp.com",
    projectId: "smooth-rider",
    storageBucket: "smooth-rider.appspot.com",
    messagingSenderId: "1068885497995",
    appId: "1:1068885497995:web:b5f096029d04c53f715c8e"
  };

  export default firebaseConfig;